<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
const warningSegments = computed(() => [
  {
    text: `${t('SALES_PARTIES.PERSONAL.MARRIAGE_AGREEMENT_WARNING_PREFIX')} `,
  },
  {
    emphasis: true,
    text: t('SALES_PARTIES.PERSONAL.MARRIAGE_AGREEMENT_WARNING_HIGHLIGHT'),
  },
  {
    text: t('SALES_PARTIES.PERSONAL.MARRIAGE_AGREEMENT_WARNING_SUFFIX'),
  },
]);
</script>

<template>
  <div
    v-if="show"
    role="alert"
    data-test="sales-party-marriage-agreement-alert"
    class="flex w-full items-start gap-3 rounded-lais-sm border border-lais-warning/40 bg-lais-warning/10 px-4 py-3 text-sm leading-5 text-lais-text sm:col-span-2"
  >
    <span
      class="i-lucide-circle-alert mt-0.5 size-5 shrink-0 text-lais-warning"
      aria-hidden="true"
    />
    <p class="min-w-0 flex-1">
      <component
        :is="segment.emphasis ? 'strong' : 'span'"
        v-for="segment in warningSegments"
        :key="segment.text"
      >
        {{ segment.text }}
      </component>
    </p>
    <button
      type="button"
      :aria-label="t('SALES_PARTIES.COMMON.CLOSE_NOTICE')"
      class="i-lucide-x size-5 shrink-0 text-lais-text-muted outline-none hover:text-lais-text focus-visible:ring-2 focus-visible:ring-lais-warning"
      @click="emit('close')"
    />
  </div>
  <span v-else class="hidden" aria-hidden="true" />
</template>
